<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>发货详情</span>
    </div>
    <el-steps
      v-show="type === '入库'"
      :active="dataList.deliverState + 1"
      style="margin:auto;background-color: #F5F7FC;padding:20px;margin-top:20px;"
    >
      <el-step title="完善发货信息" icon="el-icon-success"></el-step>
      <el-step title="物流在途" icon="el-icon-success"></el-step>
      <el-step title="待入库" icon="el-icon-success"></el-step>
      <el-step title="已入库" icon="el-icon-success"></el-step>
    </el-steps>
    <div style="background-color: #F5F7FC;padding:20px;margin-top:20px;" v-show="type === '直发'">
      <el-steps :active="2" style="width:300px;margin:auto;">
        <el-step title="完善发货信息" icon="el-icon-success"></el-step>
        <el-step title="已发货" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <el-row style="margin:20px 0;" v-show="type === '入库'">
      <el-col :span="12">入库单：{{ dataList.instockNumber }}</el-col>
      <el-col
        :span="12"
        style="text-align:right;"
        v-show="(dataList.deliverState===2||dataList.deliverState===3)&&dataList.purchaseStorageVo.logisticType ==='供应商配送'"
      >
        <el-button type="primary" @click="exportWarehousing" plain>导出入库单</el-button>
      </el-col>
    </el-row>
    <p v-show="type === '直发'" class="title-p">发货清单</p>
    <el-table
      border
      ref="tableRef"
      :data="list"
      style="margin-top:20px;"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loading"
      max-height="378px"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="brandName" show-overflow-tooltip label="品牌"></el-table-column>
      <el-table-column prop="seriesName" show-overflow-tooltip width="150px" label="系列"></el-table-column>
      <el-table-column prop="proName" show-overflow-tooltip width="150px" label="产品名称"></el-table-column>
      <el-table-column prop="proModel" show-overflow-tooltip width="150px" label="型号"></el-table-column>
      <el-table-column prop="proOrderNum" show-overflow-tooltip width="150px" label="订货号"></el-table-column>
      <el-table-column prop="proUnit" label="单位"></el-table-column>
      <el-table-column prop="deliverCount" label="发货数量"></el-table-column>
      <el-table-column prop="warehouseCount" label="实际入库数量" v-show="type === '入库'" width="110px">
        <template slot-scope="scope">
          <div>{{ scope.row.warehouseCount }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="单品报价">
        <template slot-scope="scope">
          <div>{{ scope.row.purchasePrice|priceFilterNum }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="报价总额">
        <template slot-scope="scope">
          <div>{{ scope.row.total|priceFilterNum }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="proPrice" label="面价">
        <template slot-scope="scope">
          <div>{{ scope.row.proPrice|priceFilterNum }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="deliverStates" label="发货状态">
        <template slot-scope="scope">
          <div>{{ statusList[scope.row.deliverStates - 1] }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="invoiceState" label="收票状态">
        <template slot-scope="scope">
          <div>{{ dataValue[scope.row.invoiceState-1]}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="mark" label="备注" v-show="type === '入库'">
        <template slot-scope="scope">
          <div>{{ scope.row.mark }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="item-box-content">
      <p class="title-p">物流信息</p>
      <el-form label-width="80px">
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='物流配送'">
          <el-col :span="8">
            <el-form-item label="配送方式：">
              {{
              dataList.purchaseStorageVo.logisticType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流费用：" v-show="type === '入库'">
              {{
              dataList.purchaseStorageVo.expressFee
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='物流配送'">
          <el-col :span="8">
            <el-form-item label="物流公司：">
              {{
              dataList.purchaseStorageVo.logisticCompany
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流单号：">
              <el-col :span="20" class="flexitem">
                <el-tooltip
                  :content="dataList.purchaseStorageVo.logisticNumber"
                  class="overflow-ellipsis"
                  effect="dark"
                  placement="top"
                >
                  <span >{{dataList.purchaseStorageVo.logisticNumber|| '--'}}</span>
                </el-tooltip>
                <el-button
                  style="margin-left:10px;"
                  type="primary"
                  @click.stop="copyCode(dataList.purchaseStorageVo.logisticNumber)"
                  plain
                >复制</el-button>
              </el-col>
              <!-- <el-col :span="4">
                <el-button
                  style="margin-left:10px;"
                  type="primary"
                  @click.stop="copyCode(dataList.purchaseStorageVo.logisticNumber)"
                  plain
                >复制</el-button>
              </el-col> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='快递配送'">
          <el-col :span="8">
            <el-form-item label="配送方式：">
              {{
              dataList.purchaseStorageVo.logisticType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="快递费用：" v-show="type === '入库'">
              {{
              dataList.purchaseStorageVo.expressFee
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='快递配送'">
          <el-col :span="8">
            <el-form-item label="快递公司：">
              {{
              dataList.purchaseStorageVo.expressCompany
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="快递单号：">
              {{
              dataList.purchaseStorageVo.expressName
              }}
              <el-button
                style="margin-left:10px;"
                type="primary"
                @click.stop="copyCode(dataList.purchaseStorageVo.expressName)"
                plain
              >复制</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='供应商配送'">
          <el-col :span="8">
            <el-form-item label="配送方式：">
              {{
              dataList.purchaseStorageVo.logisticType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计到达时间：" label-width="120px" labe v-show="type === '入库'">
              {{
              dataList.purchaseStorageVo.supplierDeliverDate | dateFilterD
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-show="dataList.purchaseStorageVo.logisticType ==='供应商配送'">
          <el-col :span="8">
            <div style="margin-bottom:20px;margin-left:8px;">供应商配送时请携带入库单，交予仓储核收</div>
          </el-col>
        </el-row>

        <div v-show="type === '入库'">
          <p class="title-p">入库验收</p>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="验收结果：">{{ dataList.inState }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="dataList.deliverState === 3 ||dataList.deliverState === 4">
            <el-col :span="8">
              <el-form-item label="处理人：">{{dataList.dealUser|| '--'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属部门：">{{dataList.dealOrg|| '--' }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处理时间：">{{dataList.dealDate| dateFilterL}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="dataList.storageMark">
            <el-col :span="18">
              <el-form-item label="反馈内容：">{{ dataList.storageMark}}</el-form-item>
            </el-col>

            <el-col :span="8">
              <div style="margin-left:8px;color:#C11A1A;">缺失产品已打回待发货产品列表，可重新发起发货。</div>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { formatDate, downLoadFileBlob } from '@/util/tool'
import {
  addStorageInstockCoeDerive,
  addStorageInstockCoeDeriveProcessed
} from '@/api/purchase/purchaseManage'
export default {
  props: ['pcdbId'],
  data() {
    return {
      stateList: ['待验证', '已验证', '待上架', '已上架', '已作废'],
      statusList: ['物流在途', '验收', '已入库', '已作废', '已发货'],
      dataValue: ['未收票', '已收票', '已退票'],
      list: [],
      loading: false,
      type: '',
      dataList: {
        purchaseStorageVo: {
          logisticType: '',
          expressFee: '',
          logisticCompany: '',
          logisticNumber: ''
        }
      }
    }
  },
  methods: {
    exportWarehousing() {
      const queryParams = {}
      queryParams.bizId = this.pcdbId
      queryParams.instockType = 1
      queryParams.instockUrl = this.$store.state.supplierInventoryListGuid
      if (this.dataList.deliverState === 2) {
        addStorageInstockCoeDerive(queryParams)
          .then(res => {
            downLoadFileBlob(this, res)
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        addStorageInstockCoeDeriveProcessed(queryParams)
          .then(res => {
            downLoadFileBlob(this, res)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    copyCode(data) {
      this.$copy(data)
    },
    // 数据传递
    onInitial(type, val) {
      this.type = type
      this.list = val.purchaseContractDeliverBaseListVoList
      this.dataList = val
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style scoped>
.title-p {
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 600;
}
.flexitem{
  display: flex;
  align-items: center;
}
</style>
